module.exports = __webpack_public_path__ + "img/rr-logo.339413f0.jpg";